module.exports = __webpack_public_path__ + "static/media/How can I automatically link attachments to a letter template.e943589c.png";